import { render } from "./ImpressumTitle.vue?vue&type=template&id=3ab55076"
import script from "./ImpressumTitle.vue?vue&type=script&lang=js"
export * from "./ImpressumTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__